// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"db1eb916","104":"798f11ea","195":"5e92b855","588":"921bc106","853":"754d786e","987":"74487fd4"}[chunkId] + ".chunk.css";
};